import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

function SearchField({ value, onChange, placeholder = 'Pesquisar', sx, ...rest }) {
  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      size="small"
      sx={{ minWidth: 220, backgroundColor: 'background.paper', borderRadius: 2, ...sx }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}

export default SearchField;
